import { WorkflowActionValidationModalData } from '@components/modals/workflowActionValidationModal/WorkflowActionValidationModal';

const useWorkflowActionValidationModalEventHandlers = () => {
    return {
        onClose: (modalData: WorkflowActionValidationModalData) => {
            const { onCanceled } = modalData;

            if (onCanceled) {
                onCanceled();
            }
        },
    };
};

export default useWorkflowActionValidationModalEventHandlers;
